import * as moment from 'moment';
import { ICenterBase, ICprScoreAudit } from '@nkr/models/index';

interface IState {
    data: ICprScoreAudit[],
    initialLoad: boolean,
    center: ICenterBase,
    reportStart: string,
    newReportStart: string,
    reportEnd: string,
    newReportEnd: string,
    included: boolean,
    compatible: boolean,
    transplanted: boolean,
    expandHelp: boolean
}

const initialState: IState = {
    data: [],
    initialLoad: true,
    reportStart: moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD'),
    newReportStart: moment().startOf('month').subtract(6, 'months').format('YYYY-MM-DD'),
    reportEnd: moment().startOf('month').subtract(1, 'days').format('YYYY-MM-DD'),
    newReportEnd: moment().startOf('month').subtract(1, 'days').format('YYYY-MM-DD'),
    center: null,
    included: true,
    compatible: false,
    transplanted: null,
    expandHelp: false
};

type Action =
    | { type: 'initialize', payload: IState }
    | { type: 'afterGetData', payload: { data: ICprScoreAudit[], center: ICenterBase, reportStart: string, newReportStart: string, reportEnd, newReportEnd: string, included: boolean, compatible: boolean, transplanted: boolean } }
    | { type: 'refreshData', payload: { data: ICprScoreAudit[], center: ICenterBase, reportStart: string, reportEnd } }
    | { type: 'updateField', payload: { name: string, value: any } }
    | { type: 'updateDateRange', payload: { reportStart: string, reportEnd: string } }
    | { type: 'compatibleOrIncludedTotalOnly', payload: { included: boolean, compatible: boolean, transplanted: boolean } }

const reducer = (state: IState, action: Action): IState => {
    switch (action.type) {
        case 'initialize':
            return { ...action.payload };

        case 'afterGetData':
            return { ...state, ...action.payload, initialLoad: false };

        case 'refreshData':
            return { ...state, ...action.payload };

        case 'updateField':
            return { ...state, [action.payload.name]: action.payload.value };

        case 'updateDateRange':
            return { ...state, reportStart: action.payload.reportStart, reportEnd: action.payload.reportEnd };

        case 'compatibleOrIncludedTotalOnly':
            return { ...state, included: action.payload.included, compatible: action.payload.compatible, transplanted: action.payload.transplanted };

        default:
            return { ...state };
    }
}

export { initialState, reducer };